var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
import { GameConfiguratorSingleton } from './GameConfiguratorSingleton';
import { CELL_SIZE } from '@static/game';
import { EnemyFactory, ENEMY_TYPE } from '@components/enemies/EnemyFactory';
var EnemiesServiceImpl = /** @class */ (function () {
    function EnemiesServiceImpl() {
        var _this = this;
        var enemyCreationInterval = 5000;
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._enemies = [];
        this._isEnemyGotBase = false;
        setInterval(function () {
            _this.appendEnemy();
        }, enemyCreationInterval);
    }
    EnemiesServiceImpl.prototype.appendEnemy = function () {
        var enemyType = Math.random() > 0.75 ? ENEMY_TYPE.DEVIL : ENEMY_TYPE.GOBLIN;
        var yPosition = Math.floor(Math.random() * 5 + 1) * CELL_SIZE;
        this._enemies.push(EnemyFactory.createEnemy(enemyType, yPosition));
    };
    EnemiesServiceImpl.prototype.removeEnemyByIndex = function (index) {
        this._enemies.splice(index, 1);
    };
    EnemiesServiceImpl.prototype.drawEnemies = function () {
        var _this = this;
        this._enemies.forEach(function (enemy) {
            enemy.move();
            enemy.draw();
            if (enemy.x < 0) {
                _this._isEnemyGotBase = true;
            }
        });
    };
    Object.defineProperty(EnemiesServiceImpl.prototype, "isEnemyGotBase", {
        get: function () {
            return this._isEnemyGotBase;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EnemiesServiceImpl.prototype, "enemies", {
        get: function () {
            return this._enemies;
        },
        enumerable: false,
        configurable: true
    });
    EnemiesServiceImpl = __decorate([
        injectable()
    ], EnemiesServiceImpl);
    return EnemiesServiceImpl;
}());
export { EnemiesServiceImpl };
